import { LengthRange } from '../types/lengthRange';

export const clamp = (value: number, min: number, max: number): number => Math.max(Math.min(value, max), min);

export const calculateOverlapPercentage: (range: LengthRange, totalRange: LengthRange) => number = (
	range: LengthRange,
	totalRange: LengthRange,
): number => {
	if (range.depthTo < totalRange.depthFrom) return 0;
	if (range.depthFrom > totalRange.depthTo) return 0;
	return (
		(Math.min(range.depthTo, totalRange.depthTo) - Math.max(range.depthFrom, totalRange.depthFrom)) /
		(totalRange.depthTo - totalRange.depthFrom)
	);
};
